var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.vehiculo.estadoVehiculoDespacho !== 'innactivo')?_c('GmapMarker',{attrs:{"position":_vm.position,"icon":_vm.carroMarkerIcon,"label":{
    text: _vm.vehiculo.denominacion,
    color: 'white',
    className: 'carro-numero'
  }}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }